import React, { useEffect, useRef } from 'react';
import sponsorData from '../Sponsors/sponsorData';
import SponsorLogo from '../Sponsors/SponsorLogo';

const SPEED = 0.7; // px per frame
const RESUME_DELAY = 2000; // ms after interaction before auto-scroll resumes

// Triple the data so we always have a full set ahead and behind for seamless looping
const tripled = [...sponsorData, ...sponsorData, ...sponsorData];

function Sponsors2() {
    const trackRef = useRef(null);
    const posRef = useRef(0);
    const pausedRef = useRef(false);
    const rafRef = useRef(null);
    const resumeTimer = useRef(null);
    const dragStartX = useRef(null);
    const dragStartPos = useRef(null);

    useEffect(() => {
        const track = trackRef.current;

        const tick = () => {
            if (!pausedRef.current) {
                // singleSetWidth = width of one full set (1/3 of tripled track)
                const singleSetWidth = track.scrollWidth / 3;
                posRef.current += SPEED;
                if (posRef.current >= singleSetWidth) posRef.current -= singleSetWidth;
                track.style.transform = `translateX(-${posRef.current}px)`;
            }
            rafRef.current = requestAnimationFrame(tick);
        };

        rafRef.current = requestAnimationFrame(tick);
        return () => {
            cancelAnimationFrame(rafRef.current);
            clearTimeout(resumeTimer.current);
        };
    }, []);

    const scheduleResume = () => {
        clearTimeout(resumeTimer.current);
        resumeTimer.current = setTimeout(() => {
            pausedRef.current = false;
        }, RESUME_DELAY);
    };

    const onPointerDown = (e) => {
        pausedRef.current = true;
        clearTimeout(resumeTimer.current);
        dragStartX.current = e.clientX;
        dragStartPos.current = posRef.current;
        // capture so pointermove fires even if cursor leaves the element
        trackRef.current.setPointerCapture(e.pointerId);
    };

    const onPointerMove = (e) => {
        if (dragStartX.current === null) return;
        const delta = dragStartX.current - e.clientX;
        const track = trackRef.current;
        const singleSetWidth = track.scrollWidth / 3;
        // wrap to [0, singleSetWidth) so the loop stays seamless while dragging
        let newPos = dragStartPos.current + delta;
        newPos = ((newPos % singleSetWidth) + singleSetWidth) % singleSetWidth;
        posRef.current = newPos;
        track.style.transform = `translateX(-${newPos}px)`;
    };

    const onPointerUp = () => {
        if (dragStartX.current === null) return;
        dragStartX.current = null;
        dragStartPos.current = null;
        scheduleResume();
    };

    return (
        <section className="our-brand-patners section-padding pt-0 section-bg">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title-3 text-center mb-40">
                            <p>Trusted Brands</p>
                            <h1>Our Brand Partners</h1>
                        </div>
                    </div>
                </div>
            </div>

            {/* Full-width overflow clip for the marquee */}
            <div style={{ overflow: 'hidden', width: '100%' }}>
                <div
                    ref={trackRef}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        willChange: 'transform',
                        cursor: 'grab',
                        userSelect: 'none',
                        touchAction: 'pan-y', // allow vertical scroll on mobile, block horizontal
                    }}
                    onPointerDown={onPointerDown}
                    onPointerMove={onPointerMove}
                    onPointerUp={onPointerUp}
                    onPointerCancel={onPointerUp}
                    onDragStart={(e) => e.preventDefault()}
                >
                    {tripled.map((data, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={`${data.id}-${i}`} style={{ flexShrink: 0, padding: '0 24px' }}>
                            <SponsorLogo sponsorLogo={data.sponsorLogo} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Sponsors2;
